import { Box } from "@mui/material";
import { LazyImage } from "src/components/base/components/LazyImage";
import { useCssMediaQuery } from "src/components/base/hooks/useCssMediaQuery";
import { useTeamConfig } from "src/components/reusable/components/TeamConfigProvider";

export const StaticBanner = (props: {
  src: string;
  alt: string;
  isFluidImageSize?: boolean;
  mobileMaxHeight?: string;
  maxHeight?: string;
}) => {
  const { md: mdUp } = useCssMediaQuery("up");
  const { sm: smDown } = useCssMediaQuery("down");

  const bannerHeight = props?.isFluidImageSize
    ? "fit-content"
    : mdUp
      ? "450px"
      : "550px";

  return (
    <Box
      width={"100%"}
      height={props?.maxHeight || bannerHeight}
      maxHeight={
        props?.maxHeight ||
        (props?.mobileMaxHeight && smDown ? props?.mobileMaxHeight : "unset")
      }
    >
      <LazyImage
        alt={props.alt}
        src={props.src}
        width={2160}
        height={2700}
        style={{ objectFit: "cover", width: "100%", height: "100%" }}
      />
    </Box>
  );
};
